<div class="modal fade" id="loginModal" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content auth-modal-content">

            <!-- Close button -->
            <!-- <button type="button" class="btn-close position-absolute top-0 end-0 m-3" (click)="close()">
            </button> -->

            <kt-app-login
                [cssClass]="'section-auth-modal'"
                [redirectUrl]="null"
                (loginSuccess)="onLoginSuccess()"
                (forgotPassword)="onNavigateAway('/auth/forgot-password')"
                (createAccount)="onNavigateAway('/auth/sign-up')"
            />
        </div>
    </div>
</div>